<mat-card class="validate-card">
    <mat-card-header>
        <mat-card-title><fa-icon [icon]="['fas','user']"></fa-icon>&nbsp;&nbsp;Identité</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div *ngIf="displaymode === 'summary' || displaymode === 'full'" class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Prénom</mat-label>
                <input matInput [value]="patient.firstname" mat-autoresize="true" placeholder="Prénom du patient">
                <mat-hint class="hint-alert" *ngIf="cardinfo && patient.firstname != cardinfo.firstname">{{ cardinfo.firstname }}</mat-hint>
            </mat-form-field>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Nom</mat-label>
                <input matInput [value]="patient.lastname" mat-autoresize="true" placeholder="Nom du patient">
                <mat-hint class="hint-alert" *ngIf="cardinfo && patient.lastname != cardinfo.lastname">{{ cardinfo.lastname }}</mat-hint>
            </mat-form-field>
        </div>
        <div *ngIf="displaymode === 'full'" class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Prénom 2</mat-label>
                <input matInput [value]="patient.firstname2" mat-autoresize="true" placeholder="Deuxième prénom du patient">
            </mat-form-field>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Initiales</mat-label>
                <input matInput [value]="patient.initials" mat-autoresize="true" placeholder="Les initiales du patient">
            </mat-form-field>
        </div>
        <div *ngIf="displaymode === 'summary' || displaymode === 'full'" class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Date de naissance</mat-label>
                <input matInput [matDatepicker]="dp" [value]="patient.birthday" mat-autoresize="true" placeholder="Date de naissance">
                <mat-hint class="hint-alert" *ngIf="cardinfo && patientBirthday != cardinfoBirthday">{{ cardinfoBirthday }}</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Age</mat-label>
                <input matInput type="number" [value]="patient.age" mat-autoresize="true" placeholder="Age du patient">
            </mat-form-field>
        </div>
        <div class="divider-form"></div>
        <div *ngIf="displaymode === 'full'" class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label><b>NISS</b></mat-label>
                <input matInput [value]="patient.niss" mat-autoresize="true" placeholder="Numéro national">
                <mat-hint class="hint-alert" *ngIf="cardinfo && patient.niss != cardinfo.niss">{{ cardinfo.niss }}</mat-hint>
            </mat-form-field>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>N° carte identité</mat-label>
                <input matInput [value]="patient.cardid" mat-autoresize="true" placeholder="Numéro de la carte d'identité">
                <mat-hint class="hint-alert" *ngIf="cardinfo && patient.cardid != cardinfo.cardid">{{ cardinfo.cardid }}</mat-hint>
            </mat-form-field>
        </div>
    </mat-card-content>
</mat-card>
